<template>
  <div>
    <div class="content-toggle">
      <div class="toggle-search">
        <button
          type="button"
          name="btn_listLineDeals"
          class="btn_optionlogin bn_active"
        >
          <span class="cta ml-0">Todas las líneas de negocio</span>
        </button>

        <div v-for="linedeal in listLineDeals" v-bind:key="linedeal.id">
          <button
            type="button"
            name="btn_listLineDeals"
            class="btn_optionlogin"
            @click="hrefLineDeal(linedeal)"
            :class="{ bn_active: activeBtn === 'Novedades' }"
          >
            <span class="cta ml-0"> {{ linedeal.name }}</span>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

 
<script>
import { mapActions, mapState, mapGetters } from "vuex";

export default {
  name: "Businessline",
  data() {
    return {
      selected: false,
    };
  },
  props: ["row", "field"],
  computed: {
    ...mapState("modTipshiftReport", ["tipshift", "selectAll"]),
    ...mapGetters(["modTipshiftReport", ["getAllSelected"]]),
    ...mapState("modReportTips", [
      "propinasGeneral",
      "loading",
      "listLineDeals",
    ]),
  },
  methods: {
    ...mapActions("modTipshiftReport", [
      "actSaveTipshift",
      "actGetTipshift",
      "actGetSelectAll",
      "actSelectRow",
    ]),

    ...mapActions("modReportTips", [
      "actGetPropinasGeneral",
      "actSetComponentePropinas",
      "actGetZonas",
    ]),

    hrefLineDeal(linedeal) {
      if (linedeal.only_point_sale == 0) {
        this.$router.push({ path: "/reporttipslinedeal/" + linedeal.id });
      } else {
        this.$router.push({
          path:
            "/reporttipsdaily/" + linedeal.point_sale.id + "/" + linedeal.id,
        });
      }
    },

    emitSelected: function () {
      this.actSelectRow(this.row)
        .then(() => {
          console.log(this.row);
        })
        .catch((response) => {
          this.error.flag = true;
          this.error.class = "is-invalid";
          this.error.message =
            "No se pudo seleccionar todos los registros: " + response;
        });
    },
  },

  beforeMount() {},
};
</script>

<style lang="scss" scoped>
.content-toggle {
  /* _tab variants / horizontal */

  /* Auto layout */
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  padding: 0px;

  border: none;
  box-sizing: border-box;

  position: static;
  width: 376px;
  height: 56px;
  left: 28px;
  top: 228px;

  /* Inside auto layout */

  flex: none;
  order: 2;
  flex-grow: 0;
  margin: 30px 0px;

  .Novedades {
    /* Auto layout */

    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 2px;

    position: static;
    width: 16px;
    height: 16px;
    left: 128px;
    top: 12px;

    /* highlight/info/medium */

    background: #0075ff;
    border-radius: 100px;
    font-family: "Ubuntu";
    font-style: normal;
    font-weight: 500;
    font-size: 10px;
    line-height: 11px;
    /* identical to box height */

    display: flex;
    align-items: center;
    text-align: center;
    color: #ffffff;

    /* Inside auto layout */

    flex: none;
    order: 2;
    flex-grow: 0;
    margin: 0px 8px;
  }
  .toggle-search {
    /* Auto layout */

    display: flex;
    flex-direction: row;
    align-items: flex-start;
    padding: 8px;

    position: static;
    left: 0%;
    right: 0%;
    top: 0%;
    bottom: 0%;

    /* CTA/00 */

    background: #ececff;
    /* CTA/01 */

    border: 1px solid #c9caff;
    box-sizing: border-box;
    border-radius: 48px;

    /* Inside auto layout */

    flex: none;
    order: 0;
    flex-grow: 0;
    margin: 0px 0px;
  }
}
</style>